<template>
    <div
        id="kt_header_mobile"
        class="header-mobile align-items-center"
        v-bind:class="headerClasses"
    >
        <!--begin::Logo-->
        
        <div class="h-100 d-flex brand p-0">
            <a href="/" class="header-mobile-logo">
                <img alt="Logo" :src="headerLogo"/>
            </a>
            
            <div v-if="isAtlas" class="brand-name brand-atlas">
                <div class="brand-text">ATLAS</div>
                <div class="brand-text-sub">Teritorial</div>
            </div>
            
            <div v-else class="brand-name brand-gu">
                <div class="brand-text">{{ brandName }}</div>
                <div class="brand-text-sub">{{ sectionName }}</div>
            </div>
        </div>
        <!--end::Logo-->
        <!--begin::Toolbar-->
        <div class="d-flex align-items-center">
            <!--begin::Aside Mobile Toggle-->
            <button
                v-if="asideEnabled"
                class="btn p-0 burger-icon burger-icon-left"
                id="kt_aside_mobile_toggle"
            >
                <span></span>
            </button>
            <!--end::Aside Mobile Toggle-->

            <!--begin::Topbar Mobile Toggle-->
            <button
                class="btn btn-hover-text-primary p-0 ml-2"
                id="kt_header_mobile_topbar_toggle"
                ref="kt_header_mobile_topbar_toggle"
            >
                <span class="svg-icon svg-icon-xl" v-if="!isAtlasPublicView">
                    <!--begin::Svg Icon | path:svg/icons/General/User.svg-->
                    <inline-svg class="svg-icon mr-0" :src="userIcon" />
                    <!--end::Svg Icon-->
                </span>
            </button>
            <!--end::Topbar Mobile Toggle-->
        </div>
        <!--end::Toolbar-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StLayoutHeaderTopbar from '@/assets/js/layout/base/header-topbar.js';

export default {
    name: 'HeaderMobile',
    components: {},
    mounted() {
        // Init Header Topbar For Mobile Mode
        StLayoutHeaderTopbar.init(this.$refs['kt_header_mobile_topbar_toggle']);
    },
    props: {
        isAtlasPublicView: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['layoutConfig', 'getClasses', 'selectedMenu']),

        /**
         * Get header logo
         * @returns {string}
         */
        headerLogo() {
            return process.env.BASE_URL + this.layoutConfig('self.logo');
        },
        userIcon() {
            return process.env.BASE_URL + 'media/svg/icons/general/User.svg';
        },

        /**
         * Get classes for mobile header
         * @returns {null|*}
         */
        headerClasses() {
            const classes = this.getClasses('header_mobile');
            if (typeof classes !== 'undefined') {
                return classes.join(' ');
            }
            return null;
        },

        /**
         * Check if the left aside menu is enabled
         * @returns {boolean}
         */
        asideEnabled() {
            return !!this.layoutConfig('aside.self.display');
        },

        brandName() {
            return this.layoutConfig('self.brand');
        },
        sectionName() {
            return this.layoutConfig('self.section');
        },

        isAtlas() {
            return this.selectedMenu === 'atlas';
        },
    },
};
</script>
